import { Button, Icon } from '@lounge-fe/ui-kit'
import { SignupFormLayout } from '../SignupFormLayout'
import { SuccessMessageProps } from './types'
import { Text } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { twMerge } from 'tailwind-merge'
import {
  useContentBackground,
  contentAlignmentMap,
  contentPositionMap,
} from '../../hooks/useContentLayout'

export const SuccessMessage = ({
  title,
  subtitle,
  buttonText,
  buttonUrl,
  isDarkMode = false,
  password,
  contentAlignment = 'left',
  contentBackground = 'transparent',
  passwordCopyContent,
}: SuccessMessageProps) => {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  const contentBackgroundClass = useContentBackground(contentBackground)

  const copy = (text: string) => {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  return (
    <SignupFormLayout.FormContainer
      className={twMerge(
        'max-h-max transition-[backdrop-filter] duration-300',
        contentAlignmentMap[contentAlignment],
        contentBackgroundClass,
      )}
    >
      <SignupFormLayout.Title>{title}</SignupFormLayout.Title>
      <SignupFormLayout.Subtitle>{subtitle}</SignupFormLayout.Subtitle>
      {password && (
        <div className="block max-w-min p-6 bg-surface-secondary rounded-lg max-w-max">
          {passwordCopyContent && (
            <Text variant="body-lg" className="mb-2">
              {passwordCopyContent}
            </Text>
          )}
          <div
            className="flex gap-4 cursor-pointer"
            onClick={() => copy(password)}
          >
            <Text variant="title-four">
              {copied ? t('general.copied') : password}
            </Text>{' '}
            <Icon.Copy className="w-4 h-4" />
          </div>
        </div>
      )}
      {buttonUrl && buttonText && (
        <Button
          as="a"
          href={buttonUrl}
          color={isDarkMode ? 'secondary' : 'primary'}
          className="mt-4"
        >
          {buttonText}
        </Button>
      )}
    </SignupFormLayout.FormContainer>
  )
}
